import { errorPopup } from './lib/error-popup/errorPopup';
import { successPopup } from './lib/success-popup/successPopup';
import { blockPopup } from './lib/block-popup/blockPopup';

export const Popup = {
  error: errorPopup,
  success: successPopup,
  block: blockPopup,
} as const;
